module.exports = __webpack_public_path__ + "static/mid-6e49a9996ced02e42be07b61fe10d72b.png";